import * as yup from 'yup';

/**
 * use in authentication page > Mobile
 * @param {*} intl
 */
const mobileSchema = (intl) => {
  const phoneRegExp = /^\+(?:[0-9] ?){6,14}[0-9]$/;
  return yup.object().shape({
    phoneNumber: yup
      .string()
      .required(intl.formatMessage({ id: 'validation.mobileRequired' }))
      .min(11, intl.formatMessage({ id: 'validation.invalidMobile' }))
      .matches(phoneRegExp, intl.formatMessage({ id: 'validation.invalidMobileFormat' })),
  });
};

export default mobileSchema;
